import { render } from "./HomeContentClassic.vue?vue&type=template&id=5e2143c7&scoped=true"
import script from "./HomeContentClassic.vue?vue&type=script&lang=ts"
export * from "./HomeContentClassic.vue?vue&type=script&lang=ts"

import "./HomeContentClassic.vue?vue&type=style&index=0&id=5e2143c7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e2143c7"

export default script